import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminAuthApi, setOpsToken } from '../services/api';

export default function AdminLogin() {
  const nav = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const { token } = await adminAuthApi.login(username, password);
      setOpsToken(token);
      nav('/admin');
    } catch (err) {
      if (err.status === 429) setError('Too many failed attempts. Try again in 15 minutes.');
      else if (err.status === 403) setError('This account is disabled.');
      else setError('Invalid username or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card stack-lg">
        <h1 className="h1">Fair Ops Dashboard</h1>
        <form className="stack" onSubmit={submit}>
          <div>
            <label className="label" htmlFor="u">Username</label>
            <input id="u" className="input" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" required />
          </div>
          <div>
            <label className="label" htmlFor="p">Password</label>
            <input id="p" className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
          </div>
          {error ? <div className="badge danger">{error}</div> : null}
          <button className="btn full" type="submit" disabled={loading}>
            {loading ? <span className="spinner" /> : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
